import { render, staticRenderFns } from "./DealBanner.vue?vue&type=template&id=e0af7fa6"
import script from "./DealBanner.vue?vue&type=script&lang=js"
export * from "./DealBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/rouvenpajewski/Documents/Projekte/kuipers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0af7fa6')) {
      api.createRecord('e0af7fa6', component.options)
    } else {
      api.reload('e0af7fa6', component.options)
    }
    module.hot.accept("./DealBanner.vue?vue&type=template&id=e0af7fa6", function () {
      api.rerender('e0af7fa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/vue/DealBanner.vue"
export default component.exports